import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import { MenuItem, Select, Stack, Typography } from '@mui/material';
import { useEffect, useLayoutEffect, useState } from 'react';
import { MOURiskAction, MOURiskFetch } from '../../features/mou-risk.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';

interface PscMouProps {
    imoNumber: string;
}

const PscMou = ({ imoNumber }: PscMouProps) => {
    const dispatch = useAppDispatch();

    const mouData = useAppSelector((state) => state.MOURisk.List[imoNumber]);
    const mouSelected = useAppSelector((state) => state.MOURisk.Selected[imoNumber]);

    const portCodeData = useAppSelector((state) => state.PortCode.List[imoNumber]);

    const [selectedMOU, setSelectedMOU] = useState<string>('');

    useLayoutEffect(() => {
        setSelectedMOU('');
    }, [imoNumber]);

    useEffect(() => {
        if (!mouData) dispatch(MOURiskFetch.GetByIMONumber(imoNumber));
    }, [imoNumber]);

    useEffect(() => {
        if (portCodeData?.PortCode?.MOU && portCodeData?.PortCode.MOU.length > 0) {
            setSelectedMOU(portCodeData?.PortCode?.MOU[0].toLowerCase());
        }
    }, [portCodeData]);

    useEffect(() => {
        dispatch(MOURiskAction.SelectByVesselMOU({ IMONumber: imoNumber, MOU: selectedMOU }));
    }, [selectedMOU]);

    useEffect(() => {
        if (!mouSelected || !mouSelected.MOU) return;

        if (selectedMOU !== mouSelected.MOU) {
            setSelectedMOU(mouSelected.MOU.toLowerCase());
        }
    }, [mouSelected]);

    const handleMouChange = (mou: string) => {
        setSelectedMOU(mou);
    };

    return (
        <>
            {!mouData?.MOURisk?.length && !mouData?.IsLoading ? (
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <ErrorOutlineOutlined sx={{ height: '18px' }} />
                    <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                        Not Found
                        <Typography variant="caption" display="block">
                            Note: Unable to Get MOU Data
                        </Typography>
                    </Stack>
                </Stack>
            ) : (
                <>
                    <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                        <Select sx={{ width: 150, height: 50 }} displayEmpty value={selectedMOU} onChange={(event) => handleMouChange(event.target.value)}>
                            <MenuItem key={-1} value="">
                                {`-- Select --`}
                            </MenuItem>
                            {mouData?.MOURisk?.map((item, index) => (
                                <MenuItem key={index} value={item.MOU.toLowerCase()}>
                                    {item.MOU}
                                </MenuItem>
                            ))}
                        </Select>
                    </Stack>
                </>
            )}
        </>
    );
};

export default PscMou;
